console.log("sale pg");

 //slidesPerView: 2,
    //       spaceBetween: 20,
    //       loop: true,
    //       pagination: {
    //         el: swiperEl.querySelector(".swiper-pagination"),
    //         clickable: true,
    //       },
    //       breakpoints: {
    //         600: { slidesPerView: 2 },
    //         750: { slidesPerView: 3 },
    //         1024: { slidesPerView: 4 },
    //         1200: { slidesPerView: 5 },
    //       },
    //       // autoplay: {
    //       //   delay: 2000,
    //       //   disableOnInteraction: true
    //       // },

const swiperConfigs = [
  {
    class: ".swiper-one",
    config: {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: '', // Will be assigned dynamically
        prevEl: '', // Will be assigned dynamically
      },
      breakpoints: {
         600: { slidesPerView: 2 },
            750: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
      },
    },
  },
  {
    class: ".swiper-two",
    config: {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: true,
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: '', // Will be assigned dynamically
        prevEl: '', // Will be assigned dynamically
      },
      breakpoints: {
         600: { slidesPerView: 2 },
            750: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
      },
    },
  },
  {
    class: ".swiper-three",
    config: {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: '', // Will be assigned dynamically
        prevEl: '', // Will be assigned dynamically
      },
      breakpoints: {
         600: { slidesPerView: 2 },
            750: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
      },
    },
  },
];




document.addEventListener("DOMContentLoaded", function () {
   if (window.Swiper) {
    swiperConfigs.forEach(({ class: className, config }) => {
      document.querySelectorAll(className).forEach((swiperEl) => {
        // 🔁 Deep clone to avoid mutation issues
        const configClone = JSON.parse(JSON.stringify(config));

        // Assign pagination dynamically
        if (configClone.pagination && !configClone.pagination.el) {
          const paginationEl = swiperEl.querySelector(".swiper-pagination");
          if (paginationEl) {
            configClone.pagination.el = paginationEl;
          }
        }

        // Assign navigation dynamically (if used)
        if (configClone.navigation) {
          configClone.navigation.nextEl = swiperEl.querySelector(".swiper-button-next");
          configClone.navigation.prevEl = swiperEl.querySelector(".swiper-button-prev");
        }

        // 🚀 Initialize Swiper
        new Swiper(swiperEl, configClone);
      });
    });
  }
  else {
    console.error("Swiper library not loaded!");
  }

  // functionality
  const icons = document.querySelectorAll(".icon-container");
  const labels = document.querySelectorAll(".gender-label");
  

  icons.forEach(function (icon ,index) {
    icon.addEventListener("click", function () {
      const selectedTab = this.getAttribute("data-tab");
      // 1
      // 1. Update active class
      icons.forEach((i) => i.classList.remove("active"));
      labels.forEach((i) => i.classList.remove("active"));
      
      labels[index].classList.add("active");
      this.classList.add("active");

      // 2
      const genderBlocks = document.querySelectorAll("[data-gender-index]");
      genderBlocks.forEach(function (block) {
        if (block.getAttribute("data-gender-index") === selectedTab) {
          block.classList.remove("gender-hidden");
        } else {
          block.classList.add("gender-hidden");
        }
      });
    });
  });
  // functionality end

//   document.querySelectorAll('.brands-container').forEach(function(container) {
//       const sectionIndex = container.getAttribute('data-gender-index');
//       const pagination = document.querySelector(`.brands-pagination[data-gender-index="${sectionIndex}"]`);
// console.log(pagination , 'pagination')
//       if (pagination) {
//         new Ajaxinate({
//           container: `.brands-container[data-gender-index="${sectionIndex}"]`,
//           pagination: `.brands-pagination[data-gender-index="${sectionIndex}"]`,
//           loadingText: "Loading more...",
//           offset: 1000,
//           method: "scroll", // or "click"
//         });
//       }
//     });

  // var endlessScroll = new Ajaxinate({
  //   container: "#AjaxinateContainer",
  //   pagination: "#AjaxinatePagination",
  //   loadingText: "Loading more...",
  //   offset: 1000,
  //   method: "scroll",
  // });
  // console.log(endlessScroll);

  // dom loaded end
});
